module.exports = __webpack_public_path__ + "img/shop.e9c0c5e8.jpg";